module.exports = __webpack_public_path__ + "static/media/shield.f34957da.png";